import { render, staticRenderFns } from "./DashboardSystemAdmin.vue?vue&type=template&id=2ddf80c4&scoped=true"
import script from "./DashboardSystemAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardSystemAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardSystemAdmin.vue?vue&type=style&index=0&id=2ddf80c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf80c4",
  null
  
)

export default component.exports